import React from 'react';
import {Drawer, Hidden, IconButton, Divider} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import SidabarMenu from '../sidebar-menu';
import {withStyles} from '@material-ui/core/styles';
import {styles, Classes} from '../styles';

interface OwnProps {
    mobileOpen: boolean;
    onToggleSidebar: () => void;
}

type IProps = Classes & OwnProps;

const Sidebar = (props: IProps) => {
    const {classes, mobileOpen, onToggleSidebar} = props;
    return (
        <nav className={classes.drawer}>
            <Hidden mdUp={true} implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={'left'}
                    open={mobileOpen}
                    onClose={onToggleSidebar}
                    classes={{
                        paper: classes.drawerPaper
                    }}>
                    <div className={classes.drawerHeader}>
                        <IconButton onClick={onToggleSidebar}>
                            <ChevronLeftIcon/>
                        </IconButton>
                    </div>
                    <Divider/>
                    <SidabarMenu/>
                </Drawer>
            </Hidden>
            <Hidden smDown={true} implementation="css">
                <Drawer
                    classes={{
                        paper: classes.drawerPaper
                    }}
                    variant="permanent"
                    open={true}>
                    <div className={classes.toolbar} />
                    <SidabarMenu/>
                </Drawer>
            </Hidden>
        </nav>
    );
};

export default withStyles(styles)(Sidebar);
